/*
 * assets/eec.js
 * ---------------------------------------------------------------
 * Toggles de los bloques desplegables del medidor.
 *
 * Reescrito sin jQuery. Mantiene exactamente los mismos nombres de
 * función globales (showMedidor1..7, showInstruccionesPegamento) para
 * que los onclick="" que hay en las secciones "Liquid personalizado"
 * de las plantillas del medidor sigan funcionando sin tocarlas.
 *
 * Al eliminar la dependencia de jQuery se puede quitar de theme.liquid
 * la etiqueta <script src="https://code.jquery.com/jquery-3.4.1.js">,
 * que son ~280 KB sin comprimir, bloqueantes y desde un dominio ajeno.
 * ---------------------------------------------------------------
 */
(function () {
  'use strict';

  /**
   * Alterna la visibilidad de todos los elementos con la clase indicada.
   * Los bloques vienen ocultos con style="display: none" en línea, así que
   * vaciar la propiedad los devuelve a su display por defecto (block),
   * que es justo lo que hacía jQuery .show() / .hide().
   *
   * @param {string} className
   */
  function toggleByClass(className) {
    var nodes = document.getElementsByClassName(className);
    if (!nodes.length) return;

    // El primer elemento marca el estado del grupo.
    var isHidden = window.getComputedStyle(nodes[0]).display === 'none';

    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.display = isHidden ? '' : 'none';
    }

    // Si algún disparador declara aria-controls, mantenemos el estado accesible.
    var triggers = document.querySelectorAll('[aria-controls="' + className + '"]');
    for (var j = 0; j < triggers.length; j++) {
      triggers[j].setAttribute('aria-expanded', isHidden ? 'true' : 'false');
    }
  }

  // API pública: mismos nombres que la versión con jQuery.
  for (var n = 1; n <= 7; n++) {
    (function (index) {
      window['showMedidor' + index] = function () {
        toggleByClass('medidor' + index);
      };
    })(n);
  }

  window.showInstruccionesPegamento = function () {
    toggleByClass('instruccionesPegamento');
  };

  // Utilidad genérica por si más adelante se añaden bloques nuevos:
  // <a onclick="eecToggle('mi-clase')">
  window.eecToggle = toggleByClass;
})();
